<template>
  <router-view
    :name="isLoggedIn ? 'authenticated' : 'guest'"
  />
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    })
  }
}
</script>
